<script setup lang="ts">
    const { state, closeSectionSwitchNotification, confirmSectionSwitchNotification } = useSwitchNotification();
</script>

<template>
    <ClientOnly>
        <Teleport
            v-if="state.isVisible && state.mountId && state.currentCountry"
            :to="`#${state.mountId}`"
        >
            <SectionSwitchToast
                :current-country="state.currentCountry"
                :previous-country="state.previousCountry"
                @close="closeSectionSwitchNotification"
                @confirm="confirmSectionSwitchNotification"
            />
        </Teleport>
    </ClientOnly>
</template>
